/**
 * Initializes the OpinionLab library with custom data.
 *
 * Language codes that are currently supported by opinionlab (Provided by verint) ~ Phurpa
 * Spanish (Spain): ES-ES: https://secure.opinionlab.com/ccc01/comment_card_d.asp?referer=https%3A%2F%2Fsrc.mastercard.com/lang=es-es
 * Spanish (Latin America): ES-LAC: https://secure.opinionlab.com/ccc01/comment_card_d.asp?referer=https%3A%2F%2Fsrc.mastercard.com/lang=es-lac
 * French (Canada): FR-CA: https://secure.opinionlab.com/ccc01/comment_card_d.asp?referer=https%3A%2F%2Fsrc.mastercard.com/lang=fr-ca
 * Portuguese (Brazil): PT-BR: https://secure.opinionlab.com/ccc01/comment_card_d.asp?referer=https%3A%2F%2Fsrc.mastercard.com/lang=pt-br
 *
 * @param {Object} data - any data we want to attach to user feedback submissions
 */
export default function initOpinionLab (data) {
  const opinionLab = window.OOo

  /**
   * Callback to launch the feedback comment card.
   * This assigns our custom data to the OpinionLab instance.
   *
   * @param {Event} event - window event
   */
  opinionLab.inlineFeedbackShow = (event) => {
    let replacePattern = '://' + window.location.host
    let lang = document.querySelector('html').getAttribute('lang')
    let splitLang = lang.split('-')

    if (splitLang[0].toLowerCase() === 'es' && splitLang[1].toLowerCase() !== 'es') {
      lang = 'es-lac'
    }

    const allowedDomains = ['src.mastercard.com', 'checkout.mastercard.com', 'stage.src.mastercard.com']
    if (!allowedDomains.includes(window.location.host)) {
      replacePattern = '://test.checkout.mastercard.com'
    }

    opinionLab.oo_feedback = new opinionLab.Ocode({
      referrerRewrite: {
        searchPattern: /:\/\/[^/]*/,
        replacePattern: `${replacePattern}/lang=${lang}`
      },
      customVariables: data
    })

    // Now that oo_feedback has been re-initialized with the custom
    // var and context of the current page, launch the comment card
    opinionLab.oo_launch(event, 'oo_feedback')
  }

  /**
   * Launches opinionLab.
   *
   * @param {Event} event
   * @param {Object} feedback - opinionLab-structured feedback object
   */
  opinionLab.oo_launch = (event, feedback) => {
    opinionLab[feedback].show(event || window.event)
  }
}
